import { Component, Input, OnInit } from '@angular/core';

import { env } from '../../../environments/environment';
import { CrisprCartService } from '../crispr-cart.service';
import { LoginModalService } from '../../shared/login/login-modal.service';
import { AuthService } from '../../shared/auth/auth.service';
import { defs } from '../../defs';
import { CatPartDto } from '../../api/catPartDto';

@Component({
	selector: 'narwhalia-crispr-card',
	templateUrl: './crispr-card.component.html',
	styleUrls: ['./crispr-card.component.scss']
})
export class CrisprCardComponent implements OnInit {
	@Input() card: CatPartDto;
	readonly imgExtensions: string[];
	assetBaseURL = env.assetBaseURL;
	digitsInfo = defs.digitsInfo;

	constructor(
		private crisprCartService: CrisprCartService,
		private loginModalService: LoginModalService,
		private authService: AuthService
	) {
		this.imgExtensions = ['svg', 'png', 'jpg', 'jpeg', 'gif'];
	}

	ngOnInit() {
		this.card = {
			...this.card,
			picture: `${this.assetBaseURL}/crispr/${this.getPicturePath(this.card.picture)}`,
			extras: this.card.extras.map(extra => ({
				...extra,
				image: extra.image ? `${this.assetBaseURL}/crispr/extras/${extra.image}`
													 : `${this.assetBaseURL}/crispr/extras/Default.circle.svg`
			}))
		};
	}

	addToCart(item: CatPartDto) {
		if (this.authService.isLoggedIn()) {
			this.crisprCartService.addItemToCart(item);
		} else {
			this.loginModalService.open();
		}
	}

	private getPicturePath = picture => {
		if (picture) {
			if (this.imgExtensions.some(imgExtensions => picture.indexOf(imgExtensions) >= 0)) {
				return picture;
			} else {
				return `${picture}.svg`;
			}
		} else {
			return 'Default.base.svg';
		}
	};
}